/**
 * Affichage unifié des emplacements Cave / Parking / Garage (logique user
 * 2026-06-01), partagé entre le mailing PDF et le tableau Catalogue :
 *
 *   vide      → "—"
 *   Non       → "non"
 *   Inclus    → "incl. (n°)"        (numéro de l'emplacement entre parenthèses)
 *   Oui       → "oui (montant)"     (loyer entre parenthèses)
 *   Possible  → "poss (montant)"
 */

function formatMontant(val?: string | null): string {
  if (!val) return "";
  const s = String(val).trim();
  if (!s) return "";
  const n = parseFloat(s);
  if (isNaN(n)) return s;
  return `${n.toLocaleString("fr-BE")} €`;
}

export function dispoCell(
  dispo?: string | null,
  numero?: string | null,
  loyer?: string | null,
): string {
  const d = (dispo ?? "").trim();
  if (!d) return "—";
  if (d === "Non") return "non";
  if (d === "Inclus") {
    const n = (numero ?? "").trim();
    return n ? `incl. (${n})` : "incl.";
  }
  const m = formatMontant(loyer);
  if (d === "Oui") return m ? `oui (${m})` : "oui";
  if (d === "Possible") return m ? `poss (${m})` : "poss";
  return "—";
}
